import React from "react";
import FormSteps from "../components/FormSteps";
import FormJuridicalAll from "../components/FormJuridicalAll";

const JuridicalPersonForm = () => {
  return (
    <>
      <FormSteps />
      <FormJuridicalAll />
    </>
  );
};

export default JuridicalPersonForm;
